import { render, staticRenderFns } from "./SocsoNew.vue?vue&type=template&id=24ba96a8"
import script from "./SocsoNew.vue?vue&type=script&lang=js"
export * from "./SocsoNew.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports